import { Search } from "lucide-react";

import { Button } from "../../utils/components/ui/button";
import { Input } from "../../utils/components/ui/input";

type VendorManagementPageHeaderProps = {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onExport: () => void;
  onCreateVendor: () => void;
};

function VendorManagementPageHeader({
  searchTerm,
  onSearchChange,
  onExport,
  onCreateVendor,
}: VendorManagementPageHeaderProps) {
  return (
    <div className="flex flex-col gap-5 border-b border-[#E8EEF9] pb-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h1 className="text-[34px] font-semibold tracking-[-0.02em] text-[#1A5EF9]">
            Vendor Management
          </h1>
          <p className="mt-1 text-sm text-[#7A877F]">
            Track vendor balances, due invoices, and available credit in one
            place.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          {/* <Button
            variant="outline"
            className="h-11 rounded-[10px] border-[#B7CCFF] px-6 text-[#1A5EF9] hover:bg-[#EDF3FF]"
            onClick={onExport}
          >
            Export
          </Button> */}
          <Button
            className="h-11 rounded-[10px] bg-[#1A5EF9] px-6 text-white hover:bg-[#0E4FDE]"
            onClick={onCreateVendor}
          >
            New Vendor
          </Button>
        </div>
      </div>
      <div className="relative max-w-[420px]">
        <Search className="pointer-events-none absolute left-4 top-1/2 size-4 -translate-y-1/2 text-[#9BA7A0]" />
        <Input
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search vendor"
          className="h-12 rounded-[12px] border-[#E6EDF8] bg-[#F4F7FC] pl-11 text-sm shadow-none focus-visible:ring-[#C9D8FF]"
        />
      </div>
    </div>
  );
}

export default VendorManagementPageHeader;
